import React from 'react'
import Image from 'next/image'
import Link from 'next/link'
import { appstorebtn, googleplaybtn } from '../../assets'
import styles from './getstarted.module.css'

const GetStarted = () => {
  return (
    <div className={styles.getstartedcontainer}>
      <div className={styles.getstartedtopItems}>
        <div className={styles.getstartedtopContent}>
          <div className={styles.getstartedbadge}>get started</div>
          <div className={styles.getstarteddownloadtext}>Download our App</div>
        </div>
        <div className={styles.getstarteddescriptiontext}>
          Start your journey to empowering your community with our one stop app
          for building, engaging, and empowering your community
        </div>
      </div>
      <div className={styles.getstartedbuttons}>
        <Link
          target={'_blank'}
          className={styles.platformbutton}
          href={`https://apps.apple.com/ng/app/circleplug/id6462672418`}
        >
          <Image src={appstorebtn} alt='app store button' />
        </Link>

        <Link
          target={'_blank'}
          className={styles.platformbutton}
          href={`https://play.google.com/store/apps/details?id=com.shypes.circlePlug`}
        >
          <Image src={googleplaybtn} alt='google play button' />
        </Link>
      </div>
    </div>
  )
}

export default GetStarted
